import { cva } from 'class-variance-authority';

export const switchbackContentStyle = cva(
  'relative flex flex-col items-center justify-between gap-14 text-gray-900 dark:text-white lg:flex-row lg:gap-16',
  {
    variants: {
      reverse: {
        true: 'lg:flex-row-reverse',
      },
    },
    defaultVariants: {
      reverse: false,
    },
  },
);

export const switchbackImageSectionStyle = cva(
  [
    'relative size-full lg:basis-1/2',
    "after:absolute after:right-[-15px] after:top-[unset] after:z-0 after:hidden after:overflow-visible after:rounded-[650px] after:bg-[#4575b3] after:bg-opacity-[55%] after:content-['']",
    'after:h-[var(--gradient-height,80%)] after:w-[var(--gradient-width,105%)]',
    'after:bottom-[var(--gradient-bottom,21px)]',
    'after:blur-2xl after:[will-change:filter] lg:after:blur-3xl',
    "dark:after:block dark:after:content-['']",
    'lg:after:bottom-auto lg:after:top-[var(--gradient-top,40px)]',
  ],
  {
    variants: {
      disableGradient: {
        true: 'after:hidden dark:after:hidden',
      },
    },
    defaultVariants: {
      disableGradient: false,
    },
  },
);

export const switchbackImageWrapperStyle = cva('relative left-0 top-0 z-10 size-full overflow-hidden rounded-lg', {
  variants: {
    isImage: {
      false: 'min-h-[250px] bg-gray-400 sm:min-h-[431px]',
    },
  },
});
